/**
 * Hook que assina o evento labComponentState para um missionId+slideIndex
 * específico. Usado pelos master panels pra renderizar agregados em tempo real.
 */

import { useEffect, useState } from 'react'

import { useAdapter } from '../../../adapter'
import type { LabComponentStateSnapshot } from '../../../types/adapter'

export function useLabComponentState(
  missionId: string,
  slideIndex: number,
): LabComponentStateSnapshot | null {
  const adapter = useAdapter()
  const [snap, setSnap] = useState<LabComponentStateSnapshot | null>(
    adapter.getLabComponentState(missionId, slideIndex),
  )

  useEffect(() => {
    setSnap(adapter.getLabComponentState(missionId, slideIndex))
    const off = adapter.on('labComponentState', (incoming: LabComponentStateSnapshot) => {
      if (incoming.missionId === missionId && incoming.slideIndex === slideIndex) {
        setSnap(incoming)
      }
    })
    return off
  }, [adapter, missionId, slideIndex])

  return snap
}
